export default __webpack_public_path__ + "static/media/star.6aa60ba3.svg";